import { getCookieValue } from '@naturehouse/nh-essentials/lib/cookies/cookie';
import UserStateStore from './UserStateStore';

type UserState = {
    isLoggedIn: boolean;
    isLandlord: boolean;
};

export default class UserStateManager {
    private readonly COOKIE_NAME: string = 'is_logged_in';

    static #instance: UserStateManager | null = null;

    static getInstance(): UserStateManager {
        if (this.#instance === null) {
            this.#instance = new UserStateManager();
        }

        return <UserStateManager>this.#instance;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    readonly #userStateStore = UserStateStore;

    private constructor() {
        this.#checkIfUserIsLoggedIn();
    }

    public updateState({ isLandlord, isLoggedIn }: UserState): void {
        this.#userStateStore.isLandlord = isLandlord;
        this.#userStateStore.isLoggedIn = isLoggedIn;
    }

    #checkIfUserIsLoggedIn(): void {
        const cookieValue = getCookieValue(this.COOKIE_NAME);

        if (!cookieValue) {
            this.#userStateStore.resetState();
            return;
        }

        this.updateState({ isLoggedIn: true, isLandlord: cookieValue === 'landlord' });
    }
}
